import React from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import useGlobals from 'sb-hooks/useGlobals'
import { useConnect } from 'sb-redux-hook'
import { constants, mixpanel } from 'common/helpers'
import { useMemo, useMedia, useEffect, useCallback } from 'sb-hooks'

import Mobile from './Mobile/Mobile'
import ExceptMobile from './ExceptMobile/ExceptMobile'

import messages from './messages'


const NewThankYouPageFromNewPaymentFlow = (props) => {
  const { isMobile } = useMedia()

  const {
    isNewMobileThankYouPage2Enabled,
    isPremiumProductsForNotSubscribedEnabled,
  } = useGlobals(({ getFeatureToggle, getAbValue }) => ({
    isNewMobileThankYouPage2Enabled: getAbValue(constants.abTests.newMobileThankYouPage2) === 'b',
    isPremiumProductsForNotSubscribedEnabled: getFeatureToggle(constants.features.premiumProductsForNotSubscribed),
  }))

  const { email, isQueueFetched, hasProductsInQueue, hasPickedProducts } = useConnect(({
    email: 'models.me.email',
    isQueueFetched: (state) => Boolean(state.models.queue.items.length),
    hasProductsInQueue: (state) => state.models.queue.items[0] && state.models.queue.items[0].status[0] !== 'empty',
    hasPickedProducts: (state) => Boolean(state.view.pickPage.selectedItems.length),
  }))

  const isProductsSectionEnabled = useMemo(() => (
    isPremiumProductsForNotSubscribedEnabled
      ? (
        isQueueFetched
        && !hasProductsInQueue
        && isNewMobileThankYouPage2Enabled
      )
      : (
        !hasPickedProducts
        && !hasProductsInQueue
      )
  ), [ isQueueFetched, hasPickedProducts ])

  const trackAnalytics = useCallback(() => {
    mixpanel.track(constants.analyticsEvents.pageVisit.thankYou, {
      queue: hasProductsInQueue ? 'non empty' : 'empty',
    })
  }, [ hasProductsInQueue ])

  useEffect(() => {
    if (!isQueueFetched) {
      if (isPremiumProductsForNotSubscribedEnabled) {
        actions.models.queue.fetch()
      }
    }
    else {
      trackAnalytics()
    }
  }, [ hasProductsInQueue ])

  const commonProps = {
    ...props,
    email,
    isQueueFetched,
    isProductsSectionEnabled,
    messages, // TODO: move texts to components
  }

  return isMobile
    ? <Mobile {...commonProps} />
    : <ExceptMobile {...commonProps} />
}


ExceptMobile.propTypes = {
  isUpgradable: PropTypes.bool,
  isProductsSectionEnabled: PropTypes.bool,
  hasLockedProductsAfterSubscription: PropTypes.bool,
}


export default NewThankYouPageFromNewPaymentFlow
